import './AccountPage.scss';

import { b2x } from '@b2x/react/src';
import classnames from 'classnames';
import React from 'react';

import { MiscellaneousContentType } from '../contentTypes';
import { customerIsVet } from '../util';
import { AccountReferralVetSubpage } from './AccountReferralVetSubpage';
import { Page } from './Page';

export interface AccountPageProps extends b2x.AccountPageProps {}

export const AccountPage = (props: AccountPageProps) => {
  const content = b2x.useContent<MiscellaneousContentType>('MISCELLANEOUS_CONTENT');
  const { session } = b2x.useAppContext();
  const { getPagePath } = b2x.useAppStaticContext();
  const navigate = b2x.router.useNavigate();

  React.useEffect(() => {
    if (!session?.userLogged) {
      const loginPagePath = getPagePath('SITE_LOGIN');
      if (loginPagePath) {
        navigate(loginPagePath);
      }
    }
  }, [getPagePath, navigate, session?.userLogged]);

  const isVet = session?.customer?.qualifiers && customerIsVet(session.customer.qualifiers);

  return (
    <Page className={classnames('account-page', { 'account-page-vet': isVet })} noPaddingTop>
      <b2x.AccountPage
        {...props}
        customMappings={{
          SITE_CCN_REFERRAL_VET: <AccountReferralVetSubpage />,
        }}
      />
      {content?.body.accountDisclaimer && (
        <div className="container">
          <div className="col-12">
            <div className="text-center my-3 small">{b2x.formatHtml(content.body.accountDisclaimer)}</div>
          </div>
        </div>
      )}
    </Page>
  );
};
